import scrollIntoViewLib from 'scroll-into-view';

export type ParametersExceptTwoFirst<F> =
F extends (arg0: any, arg1: any, ...rest: infer R) => any ? R : never;

const scrollIntoView = (target: HTMLElement, config?: __ScrollIntoView.Settings, ...args: ParametersExceptTwoFirst<typeof scrollIntoViewLib>) => scrollIntoViewLib(target, {
  time: 500,
  isScrollable: (currentTarget: HTMLElement | Window) => currentTarget !== window || !document.body.classList?.contains('ReactModal__Body--open'),
  ...config,
  align: {
    top: 0,
    topOffset: 16,
    ...config?.align,
  },
}, ...args);

/**
 * @componentName scrollIntoView
 */
export default scrollIntoView;
